'use strict';

var dsSimpleListElCtrl = [function() {    
    var _this=this;

    this.onModalSelected = function(fieldId) {
        if (this.elements[fieldId].subItems === 'modal' || this.elements[fieldId].subItems) {
            this.elements[fieldId].subItemsCols = 'concatenate';
        }
    };
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            field: '=' ,
            elements: '='
        },
        replace: true,
        controller: dsSimpleListElCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graphBuilder/dataSourceSimplelistElDirective.html'
    };
};
